module.exports = __webpack_public_path__ + "static/media/ue4_1.c7484a55.jpg";